/**
 *  on iOS, lazyload still doesn't work 100% in some scenarios
 *  because intersection observer doesn't work as expected,
 *  so we use scroll & resize events in this case for compatibility.
 */
export default class LazyloadIOSFix {
  constructor() {
    const isIOS = this.detectContext().isIOS;
    if ( !isIOS ) return;

    // Déclenche immédiatement + écoute scroll/resize
    this.onScroll();
    window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
    window.addEventListener('resize', this.onScroll.bind(this));
  }

  detectContext() {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    const isIOS =
      /iP(hone|od|ad)/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (!isIOS) return { isIOS: false };

    const isSafari = /^((?!chrome|crios|fxios|opios|edgios).)*safari/i.test(ua);
    const isWebView = /(Version\/[\d.]+).*Mobile.*Safari/i.test(ua) === false;
    const isFacebook = /FBAN|FBAV/i.test(ua);
    const isInstagram = /Instagram/i.test(ua);
    const isTikTok = /T(t|ik)Tok/i.test(ua);

    return {
      isIOS,
      isSafari,
      isWebView,
      isFacebook,
      isInstagram,
      isTikTok,
    };
  }

  loadImage(img) {
    if (img.loading) {
      img.removeAttribute('loading'); // supprime lazy natif s’il y en avait
    }
  }

  onScroll() {
    const images = document.querySelectorAll('img[loading]');
    images.forEach(img => {
      if (!img.loading) return; // déjà chargée

      const rect = img.getBoundingClientRect();
      const inView =
        rect.top < window.innerHeight + 200 && rect.bottom > -200; // marge de sécurité

      if (inView) {
        this.loadImage(img);
      }
    });

    // Si tout est chargé, on arrête d’écouter
    if (![...images].some(img => img.loading)) {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
  }
}
